import { RouteComponentProps } from "react-router-dom";
import { ApplicationState } from "../store";
import { UserState } from "../store/User";
import { connect } from "react-redux";
import { Subscription } from "../store/Tenant";
import SectionableSettingsPage from "./settings/SectionableSettingsPage";
import { Section } from "../entities/Metadata";

export const ReportSettingsSectionKeys = {
    reports: "reports",
    odataTokens: "odataTokens"
} as const;

type ReportSettingsSectionKeys = typeof ReportSettingsSectionKeys[keyof typeof ReportSettingsSectionKeys];

const reportsSettingsSectionMap: Record<ReportSettingsSectionKeys, { name: string, iconName: string, tooltip: JSX.Element | undefined, controlName: string }> = {
    [ReportSettingsSectionKeys.reports]: {
        name: 'Reports',
        iconName: 'ReportDocument',
        tooltip: undefined,
        controlName: 'ReportsListControl',
    },
    [ReportSettingsSectionKeys.odataTokens]: {
        name: 'OData Tokens',
        iconName: 'AzureKeyVault',
        tooltip: undefined,
        controlName: 'OdataTokensListControl',
    },
}

const buildSectionSettings = (key: ReportSettingsSectionKeys, isSelected = true, isOpen = true, isAccessible = true, uiControlsSections = []): Section => ({
    id: key,
    name: reportsSettingsSectionMap[key].name,
    settings: {
        iconName: reportsSettingsSectionMap[key].iconName,
        tooltip: reportsSettingsSectionMap[key].tooltip
    },
    isSelected: isSelected,
    isOpen: isOpen,
    isAccessible: isAccessible,
    uiControls: [{
        id: key,
        type: reportsSettingsSectionMap[key].controlName,
        settings: uiControlsSections
    }]
});

type OwnProps = RouteComponentProps<{}>;
type StateProps = {
    user: UserState;
}
type Props = OwnProps & StateProps;

const ReportSettings = (props: Props) => {
    const sections: Section[] = [
        buildSectionSettings(ReportSettingsSectionKeys.reports),
        buildSectionSettings(ReportSettingsSectionKeys.odataTokens, Subscription.canODataView(props.user))
    ];

    return <SectionableSettingsPage 
        title="Report Settings"
        sections={sections}
        settingsKey="reportSettings" />
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps)(ReportSettings);